<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-body p-15 p-sm-20 p-md-25">
      <h3>{{ paimentNote.note_ref }}</h3>
      <br />
      <h5>
        Date de création :
        <b v-if="paimentNote.created_at">
          {{ getDate(paimentNote.created_at) }}</b
        >
        | <b> {{ paimentNote.zone_name }} </b> |
        <b>{{ paimentNote.agency_name }} </b> |
        <b>{{ paimentNote.for_name }} </b>
      </h5>
    </div>
  </div>


  <div
    v-if="paimentNote.statut == 0"
    class="card mb-25 border-0 rounded-0 bg-white letter-spacing"
  >
    <div class="card-header pb-2">
      <h5>List des nouveaux colis</h5>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="m-2">
        <div class="row">
          <div
            v-if="auth.can('ADD_BP_L')"
            class="col-12 col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Voir</label>
            <v-select
              v-model="users.per_page"
              :options="[10, 25, 50]"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
              @input="getRows1"
            />
            <button
              v-if="paimentNote.statut == 0"
              style="margin-right: 12px"
              class="btn btn-success"
              @click="AddNewColis"
            >
              Ajouter
            </button>
          </div>
          <div class="col-12 col-md-6">
            <div class="custom-search d-flex justify-content-end">
              <div class="form-group mb-0">
                <div class="d-flex align-items-center">
                  <input
                    v-model="searchTerm1"
                    placeholder="Chercher"
                    type="text"
                    class="form-control d-inline-block"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <vue-good-table
        :columns="columns"
        :rows="rows1"
        :select-options="{
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        }"
        responsive
        :search-options="{
          enabled: true,
          externalQuery: searchTerm1,
        }"
        @select-all="onSelectAll"
        @selected-rows-change="selectionChanged"
      >
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template #table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 v-if="props.row.replace == 1" class="text-warning">
              {{ props.row.code }}
              <feather-icon icon="RepeatIcon" />
            </h6>
            <h6 v-else-if="props.row.partial == 1" class="text-info">
              {{ props.row.code }}
              <feather-icon icon="CornerDownLeftIcon" />
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>
          <template v-else-if="props.column.field === 'status'">
            <div
              v-if="
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                globalStore.globalHelper(props.row.status_second).name
              "
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{
                '--dynamic-bg': globalStore.globalHelper(
                  props.row.status_second
                ).code_color,
              }"
            >
              {{ globalStore.globalHelper(props.row.status_second).name }}
            </div>
            <div
              v-else
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{ '--dynamic-bg': props.row.code_color }"
            >
              {{ props.row.s_name }}
            </div>
          </template>
          <template v-else-if="props.column.field === 'price'">
            <b>{{ props.row.price }}</b> DH
          </template>
          <template v-else-if="props.column.field === 'delivery_time'">
            <span v-if="props.row.delivery_time" class="text-nowrap">
              {{ getDate(props.row.delivery_time) }}
            </span>
            <span v-else class="text-nowrap" />
          </template>
          <template v-else-if="props.column.field === 'liv_fees'">
            <template
              v-if="
                (props.row.status == 'DELIVERED' ||
                  props.row.status == 'DELIVERED_PARTIAL') &&
                props.row.liv_fees_livred
              "
              ><b>{{ props.row.liv_fees_livred }}</b> DH</template
            >
            <template
              v-if="
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second == 'REFUSE' &&
                props.row.liv_fees_refused
              "
              ><b>{{ props.row.liv_fees_refused }} </b> DH</template
            >
          </template>

          <template v-else-if="props.column.field === 'total'">
            <template
              v-if="
                (props.row.status == 'DELIVERED' ||
                  props.row.status == 'DELIVERED_PARTIAL') &&
                props.row.liv_fees_livred
              "
              ><b>{{ props.row.price - props.row.liv_fees_livred }} </b>
              DH</template
            >
            <template
              v-if="
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second == 'REFUSE' &&
                props.row.liv_fees_refused
              "
              ><b>{{ 0 - props.row.liv_fees_refused }} </b> DH</template
            >
          </template>
          <span v-else-if="props.column.field === 'action'">
            <button
              type="button"
              class="btn btn-warning btn-icon"
              style="margin-right: 3px"
              title="Détails de suivi "
              @click="showDetailSuivi(props.row.id)"
            >
              <feather-icon icon="EyeIcon" />
            </button>

            <button
              type="button"
              class="btn btn-info btn-icon"
              style="margin-right: 3px"
              title="Informations de colis"
              @click="showDetails(props.row)"
            >
              <feather-icon icon="InfoIcon" />
            </button>

           
          </span>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <div class="row">
        <div
          class="col-12 col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Voir</label>
          <v-select
            v-model="users.per_page"
            :options="[10, 25, 50]"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
            @input="getRows1"
          />
          <label>de {{ users.total }} entités</label>
        </div>
        <div class="col-12 col-md-6">
          <PaginatorContent
            :pagination="users"
            :offset="9"
            @paginate="getRows1"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header pb-2">
      <h5>List des colis ajoutés</h5>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="m-2">
        <div class="row">
          <div
            v-if="auth.can('ADD_BP_L')"
            class="col-12 col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Voir</label>
            <v-select
              v-model="users1.per_page"
              :options="[10, 25, 50]"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
              @input="getRows2()"
            />
            <button
              v-if="paimentNote.statut == 0"
              style="margin-right: 12px"
              class="btn btn-danger"
              @click="RemoveNewColis"
            >
              Supprimer
            </button>
          </div>
          <div class="col-12 col-md-6">
            <div class="custom-search d-flex justify-content-end">
              <div class="form-group mb-0">
                <div class="d-flex align-items-center">
                  <input
                    v-model="searchTerm2"
                    placeholder="Chercher"
                    type="text"
                    class="form-control d-inline-block"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vue-good-table
        :columns="columns"
        :rows="rows2"
        :select-options="{
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        }"
        responsive
        :search-options="{
          enabled: true,
          externalQuery: searchTerm2,
        }"
        @select-all="onSelectAllColis"
        @selected-rows-change="selectionChangedColis"
      >
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template #table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 v-if="props.row.replace == 1" class="text-warning">
              {{ props.row.code }}
              <feather-icon icon="RepeatIcon" />
            </h6>
            <h6 v-else-if="props.row.partial == 1" class="text-info">
              {{ props.row.code }}
              <feather-icon icon="CornerDownLeftIcon" />
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>
          <template v-else-if="props.column.field === 'status'">
            <div
              v-if="
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                globalStore.globalHelper(props.row.status_second).name
              "
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{ '--dynamic-bg': ColorStatu(props.row.status_second) }"
            >
              {{ resolveStatuParcel(props.row.status_second) }}
            </div>
            <div
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{ '--dynamic-bg': props.row.code_color }"
            >
              {{ props.row.s_name }}
            </div>
          </template>
          <template v-else-if="props.column.field === 'price'">
            <b>{{ props.row.price }}</b> DH
          </template>
          <template v-else-if="props.column.field === 'delivery_time'">
            <span v-if="props.row.delivery_time" class="text-nowrap">
              {{ getDate(props.row.delivery_time) }}
            </span>
            <span v-else class="text-nowrap" />
          </template>
          <template v-else-if="props.column.field === 'liv_fees'">
            <template
              v-if="
                (props.row.status == 'DELIVERED' ||
                  props.row.status == 'DELIVERED_PARTIAL') &&
                props.row.liv_fees_livred
              "
              ><b>{{ props.row.liv_fees_livred }}</b> DH</template
            >
            <template
              v-if="props.row.status == 'REFUSE' && props.row.liv_fees_refused"
              ><b>{{ props.row.liv_fees_refused }} </b> DH</template
            >
          </template>
          <template v-else-if="props.column.field === 'total'">
            <template
              v-if="
                (props.row.status == 'DELIVERED' ||
                  props.row.status == 'DELIVERED_PARTIAL') &&
                props.row.liv_fees_livred
              "
              ><b>{{ props.row.price - props.row.liv_fees_livred }} </b>
              DH</template
            >
            <template
              v-if="props.row.status == 'REFUSE' && props.row.liv_fees_refused"
              ><b>{{ 0 - props.row.liv_fees_refused }} </b> DH</template
            >
          </template>
          <span v-else-if="props.column.field === 'action'">
            <button
              type="button"
              class="btn btn-warning btn-icon"
              style="margin-right: 3px"
              title="Détails de suivi "
              @click="showDetailSuivi(props.row.id)"
            >
              <feather-icon icon="EyeIcon" />
            </button>
            <button
              type="button"
              class="btn btn-info btn-icon"
              style="margin-right: 3px"
              title="Informations de colis"
              @click="showDetails(props.row)"
            >
              <feather-icon icon="InfoIcon" />
            </button>
            
           
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <div class="row">
        <div
          class="col-12 col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Voir</label>
          <v-select
            v-model="users1.per_page"
            :options="[10, 25, 50]"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
            @input="getRows2()"
          />
          <label>de {{ users1.total }} entités</label>
        </div>
        <div class="col-12 col-md-6">
          <PaginatorContent
            :pagination="users1"
            :offset="9"
            @paginate="getRows2"
          />
        </div>
      </div>
    </div>
  </div>

</template>


<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import router from "@/router";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import moment from "moment";
import { defineComponent, ref, reactive, onMounted } from "vue";
import { useGlobalStore } from "@/stores/global";

export default defineComponent({
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;
    const globalStore = useGlobalStore();

    const AgenciesList = ref([]);
    const ClientsList = ref([]);
    const AgencyStockList = ref([]);
    const isLoader = ref(true);
    const searchTerm1 = ref("");
    const searchTerm2 = ref("");
    const searchTearm = ref("");
    const searchTearm2 = ref("");
    const pageLength = ref(10);
    const pageLength2 = ref(10);
    // loading:false
    const columns = [
      { label: "Code Suivi", field: "code" },
      { label: "Client", field: "customer_name" },
      { label: "Téléphone", field: "customer_phone" },
      { label: "Date de livraison", field: "delivery_time" },
      { label: "Ville", field: "city_name" },
      { label: "Status", field: "status" },
      { label: "Prix", field: "price" },
      { label: "Frais", field: "liv_fees" },
      { label: "Total", field: "total" },
      // { label: "Actions", field: "action" },
    ];
    const columnsBP = [
      { label: "Ref", field: "note_ref" },
      { label: "Infos", field: "infos" },
      { label: "Total", field: "total" },
      { label: "Reste", field: "reste_amount" },
    ];
    const SelectedRows = ref([]);
    const SelectedNewRows = ref([]);
    const SelectedRowsBP = ref([]);
    const SelectedNewRowsBP = ref([]);
    const codeColis = ref("");
    const refReception = ref("");
    const rows1 = ref([]);
    const rows2 = ref([]);
    const paimentNote = ref<any>({});
    const PBRestList = ref([]);
    const BPNewRestList = ref([]);
    const color = ref("");
    const rowID = ref(null);
    const row = ref({});
    const users = reactive({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const users1 = reactive({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const PriceColis = ref({ id: "", price: "" });

    const getDate = (value: string) => {
      return moment(String(value)).format("YYYY-MM-DD HH:mm");
    };

    const ColorStatu = async (status: string) => {
      try {
        const res = await api.get(`/api/auth/ColorStatus?status=${status}`);
        color.value = res.data;
        return color.value;
      } catch (e) {
        return "";
      }
    };

     onMounted(async () => {
      getData()
    });

    const resolveStatu = (status: string) => {
      switch (status) {
        case "POSTPONED":
          return "Reporté";
        case "DELIVERED":
          return "Livré";
        case "PAID":
          return "Payé";
        case "NOT_PAID":
          return "Non Payé";
        case "Payé":
          return "info";
        case "CANCELED":
          return "Annulé";
        case "UNREACHABLE":
          return "Injoignable";
        case "RETURNED":
          return "Retourné";
        case "RECEIVED":
          return "Reçu";
        case "OUT_OF_AREA":
          return "Hors-zone";
        case "NOANSWER":
          return "Pas de réponse + SMS";
        case "SENTED":
          return "Expédié";
        case "REFUSE":
          return "Refusé";
        default:
          return status;
      }
    };

    const SearchColis = async () => {
      isLoader.value = true;
      try {
        const res = await api.get(`/api/auth/SearchColisNote`, {
          params: {
            cstmr_id: router.currentRoute.value.params.id,
            code_colis: codeColis.value,
          },
        });
        isLoader.value = false;
        if (res.data.message === "success") {
          //   const audio = new Audio(require('@/assets/sound.mp3'));
          //   audio.play();
          codeColis.value = "";
        } else if (res.data.message === "not exist") {
          //   const audio = new Audio(require('@/assets/erro.mp3'));
          //   audio.play();
          showToast("Colis n'existe pas", "error");
        }
      } catch {
        showToast("Oops... Something went wrong! Pleaz try again", "error");
      }
    };

    const onSelectAll = (params: any) => {
      SelectedRows.value = params.selectedRows;
    };
    const selectionChanged = (params: any) => {
      SelectedRows.value = params.selectedRows;
    };
    const onSelectAllColis = (params: any) => {
      SelectedNewRows.value = params.selectedRows;
    };
    const selectionChangedColis = (params: any) => {
      SelectedNewRows.value = params.selectedRows;
    };
    const onSelectAllBP = (params: any) => {
      SelectedRowsBP.value = params.selectedRows;
    };
    const selectionChangedBP = (params: any) => {
      SelectedRowsBP.value = params.selectedRows;
    };
    const onSelectAllNewBP = (params: any) => {
      SelectedNewRowsBP.value = params.selectedRows;
    };
    const selectionChangedNewBP = (params: any) => {
      SelectedNewRowsBP.value = params.selectedRows;
    };

    const getData = async () => {
      isLoader.value = true;
      try {
        const res = await api.get(`/api/auth/show_bon_pay`, {
          params: { ref: router.currentRoute.value.params.refNote },
        });
        paimentNote.value = res.data.Note;
        await getRows1();
        await getRows2();
       
      } finally {
        isLoader.value = false;
      }
    };

    const getRows1 = async (page = 1) => {
      users.current_page = page;
      const res = await api.get(
        `/api/auth/payment_colis_list?searchTerm=${users.searchTerm}&page=${users.current_page}&per_page=${users.per_page}`,
        { params: { ref: router.currentRoute.value.params.refNote } }
      );
      rows1.value = res.data.users.data;
      Object.assign(users, res.data.users);
    };

    const getRows2 = async (page = 1) => {
      users1.current_page = page;
      const res = await api.get(
        `/api/auth/colis_in_note?searchTerm=${users1.searchTerm}&page=${users1.current_page}&per_page=${users1.per_page}`,
        { params: { ref: router.currentRoute.value.params.refNote } }
      );
      rows2.value = res.data.users.data;
      Object.assign(users1, res.data.users);
    };

    const AddNewColis = async () => {
      if (SelectedRows.value.length === 0) {
        showToast("Vous pouvez pas ajouter à ce bon", "error");
        return;
      }
      const data = new FormData();
      data.append("colis", JSON.stringify(SelectedRows.value));
      data.append("note_ref", router.currentRoute.value.params.refNote as string);
      try {
        const res = await api.post(`/api/auth/add_colis_payment`, data);
        if (res.data.message === "success") {
          //   const audio = new Audio(require('@/assets/sound.mp3'));
          //   audio.play();
          showToast("ajouté avec succès", "success");
          await getData();
        } else {
          showToast("Oops... Something went wrong! Pleaz try again", "error");
        }
      } catch {
        showToast("Oops... Something went wrong! Pleaz try again", "error");
      }
    };

    const RemoveNewColis = async () => {
      if (SelectedNewRows.value.length === 0) {
        showToast("Vous pouvez pas ajouter à ce bon", "error");
        return;
      }
      const data = new FormData();
      data.append("colis", JSON.stringify(SelectedNewRows.value));
      data.append("note_ref", router.currentRoute.value.params.refNote as string);
      try {
        const res = await api.post(`/api/auth/remove_colis_list`, data);
        if (res.data.message === "success") {
          //   const audio = new Audio(require('@/assets/sound.mp3'));
          //   audio.play();
          showToast("Supprimé avec succès", "success");
          await getData();
        } else {
          showToast("Oops... Something went wrong! Pleaz try again", "error");
        }
      } catch {
        showToast("Oops... Something went wrong! Pleaz try again", "error");
      }
    };

  
    const showDetailSuivi = (id: number) => {
      rowID.value = id;
    };

    const showDetails = (rowData: any) => {
      row.value = rowData;
    };

    const showUpdate = (coli: any) => {
      row.value = coli;
    };

    const FindStatus = ($row: any) => {
      if ($row.status === "IN_PROGRESS") {
        return globalStore.globalHelper($row.status_second).name;
      }
      return $row.status;
    };

   
    function resolveStatuParcel(status) {
      if (status === "POSTPONED") return "Reporté";
      if (status === "DELIVERED") return "Livré";
      if (status === "PAID") return "Payé";
      if (status === "NOT_PAID") return "Non Payé";
      if (status === "Payé") return "Payé";
      if (status === "CANCELED") return "Annulé";
      if (status === "UNREACHABLE") return "Injoignable";
      if (status === "POSTPONED") return "Reporté";
      if (status === "RETURNED") return "Retourné";
      if (status === "RECEIVED") return "Reçu";
      if (status === "OUT_OF_AREA") return "Hors-zone";
      if (status === "NOANSWER") return "Pas de réponse + SMS";
      if (status === "SENTED") return "Expédié";
      if (status === "REFUSE") return "Refusé";
      if (status === "ONV") return "En Voyage";
      if (status === "INT") return "Client intéréssé";
      if (status === "POSTPONED_TEAM") return "Reporté ( SUIVI )";
      if (status === "CANCELED_TEAM") return "Annulé ( SUIVI )";
      if (status === "VOICEMAIL_TEAM") return "Boite Vocal ( SUIVI )";
      if (status === "EN") return "Erreur Numéro";
      return status;
    }

    return {
      AgenciesList,
      ClientsList,
      AgencyStockList,
      isLoader,
      searchTerm1,
      searchTerm2,
      searchTearm,
      searchTearm2,
      pageLength,
      pageLength2,
      columns,
      columnsBP,
      SelectedRows,
      SelectedNewRows,
      SelectedRowsBP,
      SelectedNewRowsBP,
      codeColis,
      refReception,
      rows1,
      rows2,
      paimentNote,
      PBRestList,
      BPNewRestList,
      color,
      rowID,
      row,
      users,
      users1,
      PriceColis,
      AddNewColis,
      RemoveNewColis,
      getDate,
      auth,
      user,
      SearchColis,
      onSelectAll,
      selectionChanged,
      onSelectAllColis,
      selectionChangedColis,
      onSelectAllBP,
      selectionChangedBP,
      onSelectAllNewBP,
      selectionChangedNewBP,
      getData,
      getRows1,
      getRows2,
      globalStore,
      showDetailSuivi,
      showDetails,
      showUpdate,
      FindStatus,
      ColorStatu,
      resolveStatuParcel,
    };
  },
});
</script>

